import { useSelector } from 'react-redux';
import { Group } from '@mui/icons-material';
import AddCheckInStaff from './AddCheckInStaff';
import CheckInStaffList from './CheckInStaffList';
import NoCreatedEvent from '../../../user-dashboard/my-events/NoCreatedEvent';
import useAddCheckInStaff from './hooks/useAddCheckInStaff';
import LoadingSpinner from '../../../../../animation/LoadingSpinner';
import '../../../../../styles/components/Team.css';

function CheckInManage() {
    const { 
        checkInStaffList,
        loading
    } = useSelector((state) => state.team);
    const {
        openAddCheckInStaffForm,
        setOpenAddCheckInStaffForm,
        cancelAllForm,
        deleteStaffMember,
        formik,
        addStaffMember,
        loading: updateLoader
    } = useAddCheckInStaff();

    if (loading) {
        return <LoadingSpinner message="Fetching your check-in staff..." />;
    }

    if (checkInStaffList?.data?.length === 0 && !openAddCheckInStaffForm) {
        return (
            <NoCreatedEvent
                title="No check in staff added yet!"
                description='Add check in staff to your event that helps with the check-in process.'
                btnName='Add Check in Staff'
                onClick={() => setOpenAddCheckInStaffForm(true)}
                icon={<Group color="tertiary" sx={{ fontSize: '48px' }} />}
            />
        )
    }

    return (
        <div className="event-check-in-staff">

            {(checkInStaffList?.data?.length > 0 || openAddCheckInStaffForm) && (
                <AddCheckInStaff
                    formik={formik}
                    addStaffMember={addStaffMember}
                    openAddCheckInStaffForm={openAddCheckInStaffForm}
                    onCancel={cancelAllForm}
                    deleteStaffMember={deleteStaffMember}
                    loading={updateLoader}
                />
            )}

            {checkInStaffList?.data?.length > 0 && (
                <CheckInStaffList
                    data={checkInStaffList.data}
                />
            )}
            
        </div>
    );
}

export default CheckInManage;